import {WS_INIT, WS_CLOSE} from "../constants/actionTypes";

export const wsInitAction = (config) => ({
    type: WS_INIT,
    config: config
});

export const wsCloseAction = () => ({
    type: WS_CLOSE
});